import { Env } from "./types";

export const nextJsEnv: Env = {
  APP_ENV: process.env.NEXT_PUBLIC_APP_ENV as Env["APP_ENV"],
  CDN_URL: process.env.NEXT_PUBLIC_CDN_URL as Env["CDN_URL"],
  IMAGE_CDN_URL: process.env.NEXT_PUBLIC_IMAGE_CDN_URL as Env["IMAGE_CDN_URL"],
  INTERNAL_SHOWPASS_API_URL: process.env
    .NEXT_PUBLIC_INTERNAL_SHOWPASS_API_URL as Env["INTERNAL_SHOWPASS_API_URL"],
  NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV as Env["NODE_ENV"],
  PLATFORM: process.env.NEXT_PUBLIC_PLATFORM as Env["PLATFORM"],
  SHOWPASS_API_URL: process.env
    .NEXT_PUBLIC_SHOWPASS_API_URL as Env["SHOWPASS_API_URL"],
  SITE_URL: process.env.NEXT_PUBLIC_SITE_URL as Env["SITE_URL"],
  STATE_TOKEN_SECRET_KEY: process.env
    .NEXT_PUBLIC_STATE_TOKEN_SECRET_KEY as Env["STATE_TOKEN_SECRET_KEY"],
  STATIC_FILE_PATH: process.env
    .NEXT_PUBLIC_STATIC_FILE_PATH as Env["STATIC_FILE_PATH"],
  STORYBOOK_PLATFORM: process.env
    .STORYBOOK_PLATFORM as Env["STORYBOOK_PLATFORM"],
  // Analytics
  ADWORDS_GLOBAL_TAG: process.env
    .NEXT_PUBLIC_ADWORDS_GLOBAL_TAG as Env["ADWORDS_GLOBAL_TAG"],
  FACEBOOK_TRACKING_PIXEL: process.env
    .NEXT_PUBLIC_FACEBOOK_TRACKING_PIXEL as Env["FACEBOOK_TRACKING_PIXEL"],
  GOOGLE_ANALYTICS_4_TRACKING_ID: process.env
    .NEXT_PUBLIC_GOOGLE_ANALYTICS_4_TRACKING_ID as Env["GOOGLE_ANALYTICS_4_TRACKING_ID"],
  GOOGLE_TAG_MANAGER_CONTAINER_ID: process.env
    .NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONTAINER_ID as Env["GOOGLE_TAG_MANAGER_CONTAINER_ID"],
  GOOGLE_PLACES_API_KEY: process.env
    .NEXT_PUBLIC_GOOGLE_PLACES_API_KEY as Env["GOOGLE_PLACES_API_KEY"],
  SHOWPASS_ANALYTICS_SIGNATURE_KEY: process.env
    .NEXT_PUBLIC_SHOWPASS_ANALYTICS_SIGNATURE_KEY as Env["SHOWPASS_ANALYTICS_SIGNATURE_KEY"],
  // Rokt
  ROKT_ACCOUNT_ID: process.env
    .NEXT_PUBLIC_ROKT_ACCOUNT_ID as Env["ROKT_ACCOUNT_ID"],
  // Newsletter
  NEWSLETTER_MID: process.env
    .NEXT_PUBLIC_NEWSLETTER_MID as Env["NEWSLETTER_MID"],
  NEWSLETTER_LID: process.env
    .NEXT_PUBLIC_NEWSLETTER_LID as Env["NEWSLETTER_LID"],
  NEWSLETTER_ACTION_URL: process.env
    .NEXT_PUBLIC_NEWSLETTER_ACTION_URL as Env["NEWSLETTER_ACTION_URL"],
  NEWSLETTER_THX_URL: process.env
    .NEXT_PUBLIC_NEWSLETTER_THX_URL as Env["NEWSLETTER_THX_URL"],
  NEWSLETTER_ERR_URL: process.env
    .NEXT_PUBLIC_NEWSLETTER_ERR_URL as Env["NEWSLETTER_ERR_URL"],

  // Cache
  CACHE_URL: process.env.NEXT_PUBLIC_CACHE_URL as Env["CACHE_URL"],
  EVENT_PAGE_CACHE_URL: process.env
    .NEXT_PUBLIC_EVENT_PAGE_CACHE_URL as Env["EVENT_PAGE_CACHE_URL"],

  // Sentry
  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN as Env["SENTRY_DSN"],
  ENABLE_SENTRY: process.env.NEXT_PUBLIC_ENABLE_SENTRY as Env["ENABLE_SENTRY"],

  // DataDog Rum
  DD_RUM_ENABLED: process.env
    .NEXT_PUBLIC_DD_RUM_ENABLED as Env["DD_RUM_ENABLED"],
  DD_APP_ID: process.env.NEXT_PUBLIC_DD_APP_ID as Env["DD_APP_ID"],
  DD_CLIENT_TOKEN: process.env
    .NEXT_PUBLIC_DD_CLIENT_TOKEN as Env["DD_CLIENT_TOKEN"],
  DD_SITE: process.env.NEXT_PUBLIC_DD_SITE as Env["DD_SITE"],
  DD_SERVICE: process.env.NEXT_PUBLIC_DD_SERVICE as Env["DD_SERVICE"],
  DD_ENV: process.env.NEXT_PUBLIC_DD_ENV as Env["DD_ENV"],

  APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION as Env["APP_VERSION"],
  DD_SESSION_SAMPLE_RATE: process.env
    .NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE as Env["DD_SESSION_SAMPLE_RATE"],
  DD_SESSION_REPLAY_SAMPLE_RATE: process.env
    .NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE as Env["DD_SESSION_REPLAY_SAMPLE_RATE"],
  DD_TRACK_USER_INTERACTIONS: process.env
    .NEXT_PUBLIC_DD_TRACK_USER_INTERACTIONS as Env["DD_TRACK_USER_INTERACTIONS"],
  DD_TRACK_RESOURCES: process.env
    .NEXT_PUBLIC_DD_TRACK_RESOURCES as Env["DD_TRACK_RESOURCES"],
  DD_TRACK_LONG_TASKS: process.env
    .NEXT_PUBLIC_DD_TRACK_LONG_TASKS as Env["DD_TRACK_LONG_TASKS"],

  // Protecht
  PROTECHT_API_KEY: process.env
    .NEXT_PUBLIC_PROTECHT_API_KEY as Env["PROTECHT_API_KEY"],
};

export const reactNativeEnv: Env = {
  APP_ENV: process.env.APP_ENV as Env["APP_ENV"],
  CDN_URL: process.env.CDN_URL as Env["CDN_URL"],
  IMAGE_CDN_URL: process.env.IMAGE_CDN_URL as Env["IMAGE_CDN_URL"],
  MEDIA_CDN_URL: process.env.MEDIA_CDN_URL as Env["MEDIA_CDN_URL"],
  INTERNAL_SHOWPASS_API_URL: process.env
    .INTERNAL_SHOWPASS_API_URL as Env["INTERNAL_SHOWPASS_API_URL"],
  NODE_ENV: process.env.NODE_ENV as Env["NODE_ENV"],
  PLATFORM: process.env.PLATFORM as Env["PLATFORM"],
  SHOWPASS_API_URL: process.env.SHOWPASS_API_URL as Env["SHOWPASS_API_URL"],
  SITE_URL: process.env.SITE_URL as Env["SITE_URL"],
  STATE_TOKEN_SECRET_KEY: process.env
    .STATE_TOKEN_SECRET_KEY as Env["STATE_TOKEN_SECRET_KEY"],
  STATIC_FILE_PATH: process.env.STATIC_FILE_PATH as Env["STATIC_FILE_PATH"],
  // Analytics
  ADWORDS_GLOBAL_TAG: process.env
    .ADWORDS_GLOBAL_TAG as Env["ADWORDS_GLOBAL_TAG"],
  FACEBOOK_TRACKING_PIXEL: process.env
    .FACEBOOK_TRACKING_PIXEL as Env["FACEBOOK_TRACKING_PIXEL"],
  GOOGLE_ANALYTICS_4_TRACKING_ID: process.env
    .GOOGLE_ANALYTICS_4_TRACKING_ID as Env["GOOGLE_ANALYTICS_4_TRACKING_ID"],
  GOOGLE_TAG_MANAGER_CONTAINER_ID: process.env
    .GOOGLE_TAG_MANAGER_CONTAINER_ID as Env["GOOGLE_TAG_MANAGER_CONTAINER_ID"],
  GOOGLE_PLACES_API_KEY: process.env
    .GOOGLE_PLACES_API_KEY as Env["GOOGLE_PLACES_API_KEY"],
  SHOWPASS_ANALYTICS_SIGNATURE_KEY: process.env
    .SHOWPASS_ANALYTICS_SIGNATURE_KEY as Env["SHOWPASS_ANALYTICS_SIGNATURE_KEY"],
  // Rokt
  ROKT_ACCOUNT_ID: process.env.ROKT_ACCOUNT_ID as Env["ROKT_ACCOUNT_ID"],
  // Newsletter
  NEWSLETTER_MID: process.env.NEWSLETTER_MID as Env["NEWSLETTER_MID"],
  NEWSLETTER_LID: process.env.NEWSLETTER_LID as Env["NEWSLETTER_LID"],
  NEWSLETTER_ACTION_URL: process.env
    .NEWSLETTER_ACTION_URL as Env["NEWSLETTER_ACTION_URL"],
  NEWSLETTER_THX_URL: process.env
    .NEWSLETTER_THX_URL as Env["NEWSLETTER_THX_URL"],
  NEWSLETTER_ERR_URL: process.env
    .NEWSLETTER_ERR_URL as Env["NEWSLETTER_ERR_URL"],
  // Cache
  CACHE_URL: process.env.CACHE_URL as Env["CACHE_URL"],
  EVENT_PAGE_CACHE_URL: process.env
    .EVENT_PAGE_CACHE_URL as Env["EVENT_PAGE_CACHE_URL"],
  // Sentry
  SENTRY_DSN: process.env.SENTRY_DSN as Env["SENTRY_DSN"],
  ENABLE_SENTRY: process.env.ENABLE_SENTRY as Env["ENABLE_SENTRY"],

  // Datadog RUM - React Native doesn't use these but they're required by the Env type
  DD_RUM_ENABLED: "" as Env["DD_RUM_ENABLED"],
  DD_APP_ID: "" as Env["DD_APP_ID"],
  DD_CLIENT_TOKEN: "" as Env["DD_CLIENT_TOKEN"],
  DD_SITE: "" as Env["DD_SITE"],
  DD_SERVICE: "" as Env["DD_SERVICE"],
  DD_ENV: "" as Env["DD_ENV"],
  APP_VERSION: "" as Env["APP_VERSION"],
  DD_SESSION_SAMPLE_RATE: "" as Env["DD_SESSION_SAMPLE_RATE"],
  DD_SESSION_REPLAY_SAMPLE_RATE: "" as Env["DD_SESSION_REPLAY_SAMPLE_RATE"],
  DD_TRACK_USER_INTERACTIONS: "" as Env["DD_TRACK_USER_INTERACTIONS"],
  DD_TRACK_RESOURCES: "" as Env["DD_TRACK_RESOURCES"],
  DD_TRACK_LONG_TASKS: "" as Env["DD_TRACK_LONG_TASKS"],

  // Protecht
  PROTECHT_API_KEY: process.env.PROTECHT_API_KEY as Env["PROTECHT_API_KEY"],
};
